export default function RegroupementSitesConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('regroupement.sites');
}

RegroupementSitesConfiguration.$inject = ['$translatePartialLoaderProvider'];
